module.exports = __webpack_public_path__ + "media/images/lp/lp20-107901e5e0d13dc53a979965f391377d.webp";